import { IListDataProvider } from '../interfaces/list-data-provider.interface';

/**
 * No-Op ListDataProvider für Apps ohne Lookup-Tabellen.
 */
export class NullListDataProvider implements IListDataProvider {
	getHardcoded(_tableName: string): any[] { return []; }
	getTable(_tableName: string): any[] { return []; }
}
